<template>
  <section
    class="filter-section">
    <div class="section-title">
      {{ label }}
    </div>
    <div
      v-for="(section, sectionIndex) in orderedSections"
      :key="sectionIndex">
      <SectionFilter
        v-for="(filter, filterIndex) in section.options"
        :key="filterIndex"
        :tag="filter"
        :section="section"
        :joined="sectionIndex !== 0 ? true : false"/>
    </div>
  </section>
</template>

<script>
import { orderBy } from 'lodash'
import SectionFilter from '@/components/header/filters/sidebar/SectionFilter'

export default {
  name: 'JoinedSidebarSection',

  components: {
    SectionFilter,
  },

  props: {
    value: Object,
    sections: Array,
    label: String,
  },

  computed: {
    orderedSections() {
      return orderBy(this.sections, ['filter'], ['asc'])
    },
  },
}
</script>

<style scoped lang="scss">

.filter-section {
  border-bottom: 1px solid $color-grey-lightest;
  font-size: 1.125rem;
  color: $color-grey-dark;
  padding: 1rem 2rem;
  .section-title {
    margin-bottom: 0.5rem;
  }

  // .option {
  //   cursor: pointer;
  //   color: $color-grey-main;
  //   margin-top: 0.5rem;
  // }
}
</style>
